export class InventoryDashboardMainCtrl {
    constructor (CompanyStore, $state) {
        "ngInject";
        this.store = CompanyStore;
        this.store.init();
        this.store.refresh().then(() => {
            if ($state.current.name === 'r.in.top.inventoryDashboard') {
                $state.go('r.in.top.inventoryDashboard.plant', {
                    companyId: this.store.list[0].id,
                });
            }
        });
    }
}
export class InventoryDashboardPlantCtrl {
    constructor (R, $stateParams, SecureUrlService) {
        "ngInject";
        this.companyId = $stateParams.companyId;
        this.R = R;
        this.nutrientSets = {};
        this.nutrientSetsList = [];
        this.chemicalSets = [];
        this.otherSets = [];
        this.loading = true;
        this.displayNutrients = false;
        this.displayChemicals = false;
        this.displayOthers = false;
        this.type = $stateParams.type;
        this.secureUrlService = SecureUrlService;
        this.fetchInventory();
    }

    export () {
        let self = this;
        self.secureUrlService.openInNewWindow(self.R.one('export-inventory'), {company: this.companyId});
    }

    processInventory(inventory) {
        this.loading = false;
        inventory.results.forEach((value) => {
            let configuration = value.product.configurations[0] || {};
            let group = configuration ? configuration.source_of : value.product.id;
            while (this.nutrientSets[group] && this.nutrientSets[group].length > 4) {
                group = group + '-';
            }
            let available = value.available > 0 ? value.available : 0;
            let chartData = {
                options: {
                    animation: false,
                    scales: {
                        xAxes: [{
                            stacked: true,
                        }],

                        yAxes: [{
                            stacked: false,
                            scaleLabel: {
                                display: true,
                                labelString: value.product.units.name,
                            },
                        }],
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                },
                labels: [value.product.description],
                datasets: [
                    {
                        stack: '1',
                        label: 'Available',
                        data: [available],
                        backgroundColor: '#337ab7',
                    },
                    {
                        label: 'Capacity',
                        stack: '1',
                        data: [value.capacity, 0],
                    },
                ]
            };
            if (['chemical', 'micronutrient'].indexOf(configuration.type) !== -1) {
                this.displayChemicals = true;
                this.chemicalSets.push({
                    class: 'col-sm-3',
                    charts: [chartData],
                    title: value.product.configurations[0].name ? value.product.configurations[0].name : value.product.description,
                    count: 1,
                });
            } else if(['econ', 'nutrient'].indexOf(configuration.type) !== -1) {
                this.displayNutrients = true;
                if (!this.nutrientSets[group]) {
                    this.nutrientSets[group] = {
                        charts: [chartData],
                        class: 'col-sm-3',
                        title: value.product.configurations[0].name ? value.product.configurations[0].name : value.product.description,
                        count: 1,
                    };
                } else {
                    this.nutrientSets[group].count = this.nutrientSets[group].count + 1;
                    if (this.nutrientSets[group].count === 1) {
                        this.nutrientSets[group].class = 'col-sm-3';
                        this.nutrientSets[group].chartClass = 'col-sm-12';
                    } else if (this.nutrientSets[group].count === 2) {
                        this.nutrientSets[group].class = 'col-sm-6';
                        this.nutrientSets[group].chartClass = 'col-sm-6';
                    } else if (this.nutrientSets[group].count === 3){
                        this.nutrientSets[group].class = 'col-sm-9';
                        this.nutrientSets[group].chartClass = 'col-sm-4';
                    } else {
                        this.nutrientSets[group].class = 'col-sm-12';
                        this.nutrientSets[group].chartClass = 'col-sm-3';
                    }
                    this.nutrientSets[group].charts.push(chartData);
                }
            } else {
                this.displayOthers = true;
                this.otherSets.push({
                    class: 'col-sm-3',
                    charts: [chartData],
                    title: value.product.description,
                    count: 1,
                });
            }
        });
        let tempList = [];
        for (var key in this.nutrientSets) {
            tempList.push(Object.assign({}, this.nutrientSets[key]));
        }
        tempList.sort(function(a,b) { return b.count-a.count});
        let i=0;
        while (tempList.length > 0) {
            let item = {};
            if (!(i % 4)) {
                item = tempList.shift();
            } else {
                item = tempList.pop();
            }
            i+=item.count;
            this.nutrientSetsList.push(item);
        }
    }

    fetchInventory() {
        let params = {
            company: this.companyId,
            dashboard: true,
        };
        let inventory = this.R.all('product_inventory').customGET('', params);
        inventory.then((value) => this.processInventory(value));
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/inventory/ctrls.js